import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { IntegrationModel } from 'app/models/integration.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IntegrationService extends BaseService<IntegrationModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'integration');
    }

    aircallPing(body: { apiId?: string; apiToken?: string; integration_id?: number }): Observable<{ ok: boolean; ping?: string }> {
        return this.api.postSub(`${this.endpoint}/aircall/ping`, body);
    }
}
